import { call, put, takeLatest } from 'redux-saga/effects';
import {
	fetchPatientRoisAPI,
	revokePatientRoiAPI,
	renewPatientRoiAPI,
} from 'utils/api';

import {
	fetchPatientRoisSuccess,
	fetchPatientRoisError,
	revokePatientRoiSuccess,
	revokePatientRoiError,
	renewPatientRoiSuccess,
	renewPatientRoiError,
	fetchPatientRois as fetchPatientRoisAction,
} from './actions';
import {
	FETCH_PATIENT_ROIS,
	REVOKE_PATIENT_ROI,
	RENEW_PATIENT_ROI,
} from './constants';

export function* fetchPatientRois() {
	try {
		const response = yield call(fetchPatientRoisAPI);
		yield put(fetchPatientRoisSuccess(response));
	} catch (err) {
		yield put(fetchPatientRoisError(err));
	}
}

export function* revokePatientRoi(action) {
	try {
		const response = yield call(revokePatientRoiAPI, action.roiId);
		yield put(revokePatientRoiSuccess(response));
		yield put(fetchPatientRoisAction());
	} catch (err) {
		yield put(revokePatientRoiError(err));
	}
}

export function* renewPatientRoi(action) {
	try {
		const response = yield call(renewPatientRoiAPI, action.roiId);
		yield put(renewPatientRoiSuccess(response));
		if (response && response.url) {
			window.location.href = response.url;
		}
	} catch (err) {
		yield put(renewPatientRoiError(err));
	}
}

export default function* patientRoisSaga() {
	yield takeLatest(FETCH_PATIENT_ROIS, fetchPatientRois);
	yield takeLatest(REVOKE_PATIENT_ROI, revokePatientRoi);
	yield takeLatest(RENEW_PATIENT_ROI, renewPatientRoi);
}
